var exports = {
  "n": "x8b4e8595--036006--link",
};

module.exports = exports;
